<template>  
 <div class="pr-4 scrollable-container">  
   <div style="overflow:auto;height:100%;">  
  <v-layout row wrap style="min-height:100%">    
    <v-flex xs12 style="display:flex;flex-direction:column">
      <v-card v-if="modifiedAd2cpConfig" class="pa-2" style="flex:1 1 auto;display:flex;flex-direction:column" >
        <v-card-title class="pb-0" style="flex:1 1 auto;flex-direction:column;align-items:stretch;position:relative;">         
          <v-layout row wrap class="mb-2"  style="flex:0 0 auto;">
            <span class="subheading" style="flex:0 0 auto">{{$t('Pilot.Ad2cp.Configuration')}}</span>            
            <v-switch hide-details class="pl-2 pt-0 sm-switch" v-model="config.enableAd2cp" @change="saveConfig" :label="$t('Pilot.Ad2cp.EnableAd2cp')" style="flex:0 0 auto" />
          </v-layout>
          <v-layout row wrap style="flex:1 0 auto;overflow:auto" :class="{'disable':!config.enableAd2cp}">
            <v-flex xs6 style="display:flex;flex-direction:column;">
              <v-form ref="editForm" :lazy-validation="true">
              <v-card class="mb-3 mr-2" style="flex:0 1 auto;" >
                <v-card-title class="pb-0" style="flex-direction:column;align-items:start;"><strong>{{$t('Pilot.Ad2cp.Settings')}}</strong></v-card-title>
                <v-card-text class="pt-0">                
                    <v-layout row align-end >
                      <v-flex xs7 style="overflow:hidden;">{{$t('Pilot.Ad2cp.CsName')}}</v-flex>
                      <v-flex xs5><number-field-factor height="20" single-line dense hide-details v-model="config.AD2CP_Sensor.cell_size" :label="$t('Pilot.Ad2cp.CsName')" /></v-flex>
                    </v-layout>                      
                    <v-layout row align-end>
                      <v-flex xs7 style="overflow:hidden;">{{$t('Pilot.Ad2cp.BdName')}}</v-flex>
                      <v-flex xs5>
                        <number-field-factor height="20" single-line dense hide-details v-model="config.AD2CP_Sensor.blank" :label="$t('Pilot.Ad2cp.BdName')"  />
                      </v-flex>
                    </v-layout>                      
                    <v-layout row align-end>
                      <v-flex xs7 style="overflow:hidden;">{{$t('Pilot.Ad2cp.PositionName')}}</v-flex>
                      <v-flex xs5>
                        <v-select
                            :items="positions"
                            height="20"                           
                            item-text="text"
                            item-value="value"          
                            dense hide-details                   
                            v-model="config.AD2CP_Sensor.position"
                          ></v-select>                        
                        <!--<number-field-factor height="20" single-line dense hide-details v-model="config.AD2CP_Sensor.position" :label="$t('Pilot.Ad2cp.PositionName')" />-->
                      </v-flex>
                    </v-layout>                      
                    <v-layout row align-end>
                      <v-flex xs7 style="overflow:hidden;">{{$t('Pilot.Ad2cp.CellsTransmitedName')}}</v-flex>
                      <v-flex xs5><v-text-field height="20" ref="cells" single-line dense hide-details v-model="cells" :label="$t('Pilot.Ad2cp.CellsTransmitedName')"  
                          :rules="[ruleCells]" :validate-on-blur="true" ></v-text-field>                        
                      </v-flex>
                    </v-layout>                                       
                    <v-layout row align-end>
                      <v-flex xs7 style="overflow:hidden;">{{$t('Pilot.Ad2cp.Resolution')}}</v-flex>
                      <v-flex xs5><number-field-factor height="20" single-line dense hide-details v-model.number="config.AD2CP_Sensor.win_size" :label="$t('Pilot.Ad2cp.Resolution')" /></v-flex>
                    </v-layout>  
                </v-card-text>                
              </v-card>                
              <v-card class="mb-2 mr-2" style="flex:0 1 auto;" >
                <v-card-title class="pb-0" style="flex-direction:column;align-items:start;"><strong>{{$t('Pilot.Ad2cp.QualityControl')}}</strong></v-card-title>
                 <v-card-text class="pt-0">                                                             
                    <v-layout row align-end>
                      <v-flex xs9 style="overflow:hidden;">{{$t('Pilot.Ad2cp.MaxRelSpeed')}}</v-flex>
                      <v-flex xs3><number-field-factor :positiveOnly="true" height="20" single-line dense hide-details v-model.number="maxRelSpeed" :label="$t('Pilot.Ad2cp.MaxRelDepth')" /></v-flex>
                    </v-layout>   
                    <v-layout row align-end>
                      <v-flex xs9 style="overflow:hidden;">{{$t('Pilot.Ad2cp.MaxShearSurface')}}</v-flex>
                      <v-flex xs3><number-field-factor :positiveOnly="true" height="20" single-line dense hide-details v-model.number="maxShearSurface" :label="$t('Pilot.Ad2cp.MaxShearSurface')" /></v-flex>
                    </v-layout>   
                    <v-layout row align-end>
                      <v-flex xs9 style="overflow:hidden;">{{$t('Pilot.Ad2cp.MaxShearDepth')}}</v-flex>
                      <v-flex xs3><number-field-factor :positiveOnly="true" height="20" single-line dense hide-details v-model.number="maxShearDepth" :label="$t('Pilot.Ad2cp.MaxShearDepth')" /></v-flex>
                    </v-layout>   
                    <v-layout row align-end>
                      <v-flex xs9 style="overflow:hidden;">{{$t('Pilot.Ad2cp.MaxDeviation')}}</v-flex>
                      <v-flex xs3><number-field-factor :positiveOnly="true" height="20" single-line dense hide-details v-model.number="maxDeviation" :label="$t('Pilot.Ad2cp.MaxDeviation')" /></v-flex>
                    </v-layout>   
                    <v-layout row align-end>
                      <v-flex xs9 style="overflow:hidden;">{{$t('Pilot.Ad2cp.MinNbData')}}</v-flex>
                      <v-flex xs3><number-field-factor :positiveOnly="true" height="20" single-line dense hide-details v-model.number="config.AD2CP_QC.crit_nb_data_med" :label="$t('Pilot.Ad2cp.MinNbData')" /></v-flex>
                    </v-layout>   
                    <v-layout row align-end>
                      <v-flex xs9 style="overflow:hidden;">{{$t('Pilot.Ad2cp.MaxMissingDepth')}}</v-flex>
                      <v-flex xs3><number-field-factor :positiveOnly="true" height="20" single-line dense hide-details v-model.number="config.AD2CP_QC.crit_const_pct_barocline" :label="$t('Pilot.Ad2cp.MaxMissingDepth')" /></v-flex>
                    </v-layout>             
                    <v-layout row align-end>
                      <v-flex xs9 style="overflow:hidden;">{{$t('Pilot.Ad2cp.MaxMissingTime')}}</v-flex>
                      <v-flex xs3><number-field-factor :positiveOnly="true" height="20" single-line dense hide-details v-model.number="config.AD2CP_QC.crit_const_pct_barotrope" :label="$t('Pilot.Ad2cp.MaxMissingDepth')" /></v-flex>
                    </v-layout>                     
                </v-card-text>     
              </v-card>
              </v-form>
            </v-flex>
            <v-flex xs6 style="display:flex;flex-direction:column;">
              <v-card class="ml-2" style="flex:0 1 auto;" >
                <v-card-title class="pb-0" style="flex-direction:column;align-items:start;"><strong>{{$t('Pilot.Ad2cp.Reporting')}}</strong></v-card-title>                
                 <v-card-text class="pt-0">   
                  <v-layout row align-end>
                    <v-flex xs5 style="overflow:hidden;">{{$t('Pilot.Ad2cp.LastTimeProcess')}}</v-flex>
                    <v-flex xs7 style="text-align: end;">{{config.AD2CP_state.last_process | formatDate("DD/MM/YYYY HH:mm:ss UTC")}}</v-flex>                    
                  </v-layout>
                  <v-layout row align-end>
                    <v-flex xs6 style="overflow:hidden;">{{$t('Pilot.Ad2cp.CurrentState')}}</v-flex>
                    <v-flex xs6 style="text-align: end;">{{config.AD2CP_state.current_state}}</v-flex>                    
                  </v-layout>     
                  <v-layout row align-end v-if="mission.ad2cpDataIntegrationState && mission.ad2cpDataIntegrationState.length > 0">
                    <v-flex xs6 style="overflow:hidden;">{{$t('Pilot.Ad2cp.DataIntegration')}}</v-flex>
                    <v-flex xs6 style="text-align: end;">{{$t(mission.ad2cpDataIntegrationState)}}</v-flex>                    
                  </v-layout>                  
                  <!--v-layout row align-end>
                    <v-flex xs8 style="overflow:hidden;">{{$t('Pilot.Ad2cp.Resolution')}}</v-flex>
                    <v-flex xs2><v-text-field class="mr-1" disabled height="20" single-line dense hide-details v-model="config.AD2CP_Sensor.win_size" :label="$t('Pilot.Ad2cp.Resolution')" /></v-flex>
                    <v-flex xs2><v-text-field class="ml-1" disabled height="20" single-line dense hide-details v-model="config.AD2CP_state.win_size" :label="$t('Pilot.Ad2cp.Resolution')" /></v-flex>
                  </v-layout-->
                   <v-layout row align-end>
                    <v-flex xs8 style="overflow:hidden;">{{$t('Pilot.Ad2cp.MaxRelSpeed')}}</v-flex>
                    <v-flex xs2><v-text-field class="mr-1" disabled height="20" single-line dense hide-details v-model="config.AD2CP_state.crit_speed_x" :label="$t('Pilot.Ad2cp.MaxRelDepth')" /></v-flex>
                    <v-flex xs2><v-text-field class="ml-1" disabled height="20" single-line dense hide-details v-model="config.AD2CP_state.crit_speed_x_p" :label="$t('Pilot.Ad2cp.MaxRelDepth')" /></v-flex>
                  </v-layout>
                   <v-layout row align-end>
                    <v-flex xs8 style="overflow:hidden;">{{$t('Pilot.Ad2cp.MaxShearSurface')}}</v-flex>
                    <v-flex xs2><v-text-field class="mr-1" disabled height="20" single-line dense hide-details v-model="config.AD2CP_state.crit_shear_east_top" :label="$t('Pilot.Ad2cp.MaxShearSurface')" /></v-flex>
                    <v-flex xs2><v-text-field class="ml-1" disabled height="20" single-line dense hide-details v-model="config.AD2CP_state.crit_shear_east_top_p" :label="$t('Pilot.Ad2cp.MaxShearSurface')" /></v-flex>
                  </v-layout>
                   <v-layout row align-end>
                    <v-flex xs8 style="overflow:hidden;">{{$t('Pilot.Ad2cp.MaxShearDepth')}}</v-flex>
                    <v-flex xs2><v-text-field class="mr-1" disabled height="20" single-line dense hide-details v-model="config.AD2CP_state.crit_shear_east_btm" :label="$t('Pilot.Ad2cp.MaxShearDepth')" /></v-flex>
                    <v-flex xs2><v-text-field class="ml-1" disabled height="20" single-line dense hide-details v-model="config.AD2CP_state.crit_shear_east_btm_p" :label="$t('Pilot.Ad2cp.MaxShearDepth')" /></v-flex>
                  </v-layout>
                   <v-layout row align-end>
                    <v-flex xs8 style="overflow:hidden;">{{$t('Pilot.Ad2cp.MaxDeviation')}}</v-flex>
                    <v-flex xs2><v-text-field class="mr-1" disabled height="20" single-line dense hide-details v-model="config.AD2CP_state.crit_pitch" :label="$t('Pilot.Ad2cp.MaxDeviation')" /></v-flex>
                    <v-flex xs2><v-text-field class="ml-1" disabled height="20" single-line dense hide-details v-model="config.AD2CP_state.crit_pitch_p" :label="$t('Pilot.Ad2cp.MaxDeviation')" /></v-flex>
                  </v-layout>
                   <v-layout row align-end>
                    <v-flex xs8 style="overflow:hidden;">{{$t('Pilot.Ad2cp.MinNbData')}}</v-flex>
                    <v-flex xs2><v-text-field class="mr-1" disabled height="20" single-line dense hide-details v-model="config.AD2CP_state.crit_nb_data_med" :label="$t('Pilot.Ad2cp.MinNbData')" /></v-flex>
                    <v-flex xs2><v-text-field class="ml-1" disabled height="20" single-line dense hide-details v-model="config.AD2CP_state.crit_nb_data_med_p" :label="$t('Pilot.Ad2cp.MinNbData')" /></v-flex>
                  </v-layout>
                   <v-layout row align-end>
                    <v-flex xs8 style="overflow:hidden;">{{$t('Pilot.Ad2cp.MaxMissingDepth')}}</v-flex>
                    <v-flex xs2><v-text-field class="mr-1" disabled height="20" single-line dense hide-details v-model="config.AD2CP_state.crit_const_pct_barocline" :label="$t('Pilot.Ad2cp.MaxMissingDepth')" /></v-flex>
                    <v-flex xs2><v-text-field class="ml-1" disabled height="20" single-line dense hide-details v-model="config.AD2CP_state.crit_const_pct_barocline_p" :label="$t('Pilot.Ad2cp.MaxMissingDepth')" /></v-flex>
                  </v-layout>  
                   <v-layout row align-end>
                    <v-flex xs8 style="overflow:hidden;">{{$t('Pilot.Ad2cp.MaxMissingTime')}}</v-flex>
                    <v-flex xs2><v-text-field class="mr-1" disabled height="20" single-line dense hide-details v-model="config.AD2CP_state.crit_const_pct_barotrope" :label="$t('Pilot.Ad2cp.MaxMissingDepth')" /></v-flex>
                    <v-flex xs2><v-text-field class="ml-1" disabled height="20" single-line dense hide-details v-model="config.AD2CP_state.crit_const_pct_barotrope_p" :label="$t('Pilot.Ad2cp.MaxMissingDepth')" /></v-flex>
                  </v-layout>                                  
                </v-card-text> 
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-title>      
        <v-card-actions class="pr-3" style="flex-wrap: wrap;align-items:end;">
          <v-btn class="mb-2" @click.prevent="restoreDefault" :disabled="!config.enableAd2cp" small>{{$t('Pilot.Ad2cp.ResetConfig')}}<v-icon small right>mdi-backup-restore</v-icon></v-btn>
          <v-spacer />          
          <v-btn class="mb-2" @click.prevent="run" :disabled="btnRunDisable" small>{{$t('Pilot.Ad2cp.Run')}}<v-icon small right>mdi-play</v-icon></v-btn>
          <v-btn class="mb-2" @click.prevent="restoreConfig" :disabled="!btnActif" small>{{$t('Pilot.Ad2cp.RestoreConfig')}}<v-icon small right>mdi-replay</v-icon></v-btn>
          <v-btn class="mb-2" @click.prevent="saveConfig" :disabled="!btnActif" small color="primary">{{$t('Pilot.Ad2cp.ValidateConfig')}}<v-icon small right >mdi-content-save</v-icon></v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-else class="pa-2" style="flex:1 1 auto;display:flex;flex-direction:column" >
        <v-card-title class="pb-0" style="flex:1 1 auto;flex-direction:column;align-items:start;position:relative;">
          <span>{{$t('Pilot.Ad2cp.NoDataAvailable')}}</span>
        </v-card-title>
      </v-card>
    </v-flex> 
    <!-- Dialog de chargement... -->   
    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300">
      <v-card color="primary" dark >
        <v-card-text>
          {{status}}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>   
  </v-layout>  
  </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue'
  //@ts-ignore
  import Component from 'vue-class-component'
  import deepEqual from 'deep-equal'  
  import { Watch} from 'vue-property-decorator'
  import { MissionUi } from '@/models/ui/MissionUi';  
  import { IrisConfigContainer } from '@/models/iris/IrisConfigContainer';
  import { IAd2cpConfig, getDefaultAd2cpConfig } from '@/models/iris/ad2cp/IAd2cpConfig';
  import { VuetifyConfirmObject } from 'vuetify-confirm'



  @Component({
    name: 'MissionDetailAd2cp'
  })
  export default class MissionDetailAd2cp extends Vue {  
    


    config =   {
      enableAd2cp: true, 
      ...getDefaultAd2cpConfig()           
    }

    private runDisbled = false


    get positions(){
      return [
        {value:0,text:this.$t('Pilot.Ad2cp.Bottom')},
        {value:1,text:this.$t('Pilot.Ad2cp.Top')}
      ]
    }
        
    get currentDetailMission(){
      return this.$store.myGetters.currentDetailMission
    }

    get btnRunDisable(){
      return this.loading || !this.config.enableAd2cp || this.config.AD2CP_state.current_state != "READY" || this.runDisbled
    }
    
    get btnActif() {
      const config = {}      
      this.loadConfig(config,this.originalAd2cpConfig)      
      return this.config.enableAd2cp && !deepEqual(config,this.config) && !this.loading
    }

    get cells(){
      return this.config.AD2CP_Sensor.cells && this.config.AD2CP_Sensor.cells.length > 0?this.config.AD2CP_Sensor.cells.filter(i => i && !isNaN(parseInt(i))).map(i => parseInt(i)).join(','):""
    }
    
    set cells(values){
      this.config.AD2CP_Sensor.cells = values.split(',').filter(i => i && !isNaN(parseInt(i))).map(i => i.toString())
    }

    get maxRelSpeed() {
      return this.config.AD2CP_QC.crit_speed_x
    }

    set maxRelSpeed(value) {
      this.config.AD2CP_QC.crit_speed_x = value
      this.config.AD2CP_QC.crit_speed_y = value
      this.config.AD2CP_QC.crit_speed_z = value
    }

    get maxShearSurface() {
      return this.config.AD2CP_QC.crit_shear_east_top
    }

    set maxShearSurface(value) {
      this.config.AD2CP_QC.crit_shear_east_top = value
      this.config.AD2CP_QC.crit_shear_north_top = value
    }
    
    get maxShearDepth() {
      return this.config.AD2CP_QC.crit_shear_east_btm
    }

    set maxShearDepth(value) {
      this.config.AD2CP_QC.crit_shear_east_btm = value
      this.config.AD2CP_QC.crit_shear_north_btm = value
    }

    get maxDeviation() {
      return this.config.AD2CP_QC.crit_pitch
    }

    set maxDeviation(value) {
      this.config.AD2CP_QC.crit_pitch = value
      this.config.AD2CP_QC.crit_roll = value
    }

    

    get loading(){
      return this.$store.myGetters.ad2cpLoading
    }

    get status(){
      return this.$store.myGetters.missionStatus
    }

    created() {                                 
      if(this.mission.misId != null) this.$store.myActions.MISSION_IRIS_AD2CP_REQUEST(this.mission.misId!).then(() => {
         this.loadConfig(this.config,this.modifiedAd2cpConfig)          
      })                 
    }  

    mounted() {
      /*this.loadConfig(this.config,this.modifiedAd2cpConfig)*/
    }    
   
    get mission() {
        return this.currentDetailMission.mission
    }

    get originalAd2cpConfig() {
      return this.$store.myGetters.originalAd2cpConfigs[this.mission.misId!]
    }         

    get modifiedAd2cpConfig() {
      return this.$store.myGetters.modifiedAd2cpConfigs[this.mission.misId!]
    } 

    @Watch('mission')
    onMissionChanged(newValue: any) {                        
      if(newValue.misId != null) this.$store.myActions.MISSION_IRIS_AD2CP_REQUEST(newValue.misId)      
    }
    
    @Watch('modifiedAd2cpConfig')
    onModifiedAd2cpChanged(newConfig: IrisConfigContainer<IAd2cpConfig>, oldConfig: IrisConfigContainer<IAd2cpConfig>) {            
      this.loadConfig(this.config,newConfig)      
    }

    @Watch('config', { deep: true })
    onConfigChanged(newConfig: any) {              
       this.validateConfig()
    }

    loadConfig(target:any, config: IrisConfigContainer<IAd2cpConfig>) {
      if(config && config.mod_settings) {
        target.enableAd2cp = config.mod_settings.EnabledMOD['module-AD2CP'],
        target.EnabledMOD = {...config.mod_settings.EnabledMOD},
        target.AD2CP_QC = {...config.mod_settings.AD2CP_QC},
        target.AD2CP_Sensor = {...config.mod_settings.AD2CP_Sensor}        
        target.AD2CP_state = {...config.mod_settings.AD2CP_state}                
      }
    }
    
    validateConfig() {      
      this.$store.myActions.MISSION_UPDATE_MODIFIED_AD2CP({
        itemId:this.mission.misId!,
        newProperties: {
          mod_settings:{
            EnabledMOD:{              
              'module-AD2CP': this.config.enableAd2cp
            },
            AD2CP_QC:{
              ...this.config.AD2CP_QC
            },
            AD2CP_Sensor:{
              ...this.config.AD2CP_Sensor
            }
          }
        } 
      })
    }

    saveConfig() {
      if ((this.$refs.editForm as HTMLFormElement).validate()) {
        this.validateConfig()
        this.$store.myActions.MISSION_IRIS_AD2CP_SAVE_REQUEST(this.mission.misId!)
      }
    }

    restoreConfig() {
      this.$store.myActions.MISSION_CANCEL_MODIFIED_AD2CP(this.mission.misId!)
    }
    
    restoreDefault() {
      this.config = {
        enableAd2cp: true, 
        ...getDefaultAd2cpConfig(),        
        AD2CP_state:this.config.AD2CP_state
      }
    }

    run() {
      this.runDisbled = true
      this.mission.ad2cpDataIntegrationState = 'Pilot.Ad2cp.DtiRequested'
      this.$store.myActions.MISSION_IRIS_AD2CP_RUN_REQUEST(this.mission.misId!)
      //on desactive le bouton au moins 15s
      setTimeout(() => {
        this.runDisbled = false
      }, 15000);
    }

    ruleCells(v:string) {
       return /^([0-9],?)+$/.test(v) || "Invalid Format"
    }                  
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
  .subheading,.body-2{
    font-weight: bold;  
  }

  .flex-container{
    display:flex;
    flex-direction:column;
    position:relative;
  }

  .disable{
    overflow: hidden!important;
    position: relative;
  }

 
  .disable::before{
    position: absolute;
    content: '';
    left:0px;    
    right:0px;
    top: 0px;
    height:8000%;
    background-color: rgba(0,0,0,0.3);
    z-index: 1;
  }

</style>
